const contactForm = document.getElementById('contact');
const formOverlay = document.querySelector('.contact-form-overlay');
const closeBtns = [...document.querySelectorAll('.contact-form__close')];
const openContactBtns = [...document.querySelectorAll('.contact-form-open')];

const close = () => {
  formOverlay?.classList.remove('contact-form-overlay--active');
  contactForm?.classList.remove('contact-form--active');
  document.body.style.overflow = 'auto';
};

const open = (form) => {
  formOverlay?.classList.add('contact-form-overlay--active');
  form?.classList.add('contact-form--active');
  document.body.style.overflow = 'hidden';
};

openContactBtns.forEach((btn) => {
  btn.addEventListener('click', () => open(contactForm));
});

closeBtns.forEach((btn) => {
  btn.addEventListener('click', close);
});

formOverlay?.addEventListener('click', close);

document.addEventListener('keydown', function (e) {
  if (e.keyCode == 27) close();
});
